import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable, of } from 'rxjs';

import { ModeloVistoriaApiService, modeloVistoriaVazio } from './services/modelo-vistoria-api.service';
import { ModeloVistoria } from './models/modelo-vistoria';

@Injectable()
export class EditarModeloVistoriaResolver implements Resolve<ModeloVistoria> {

  constructor(
    private modeloVistoriaApiService: ModeloVistoriaApiService,
  ) { }

  resolve(route: ActivatedRouteSnapshot): Observable<ModeloVistoria> {
    const id = Number(route.params['id']);
    if (!id) return of(modeloVistoriaVazio());

    return this.modeloVistoriaApiService.getById(id);
  }
}
